import { InputLabel as MuiInputLabel, InputLabelProps } from '@mui/material';

export default function InputLabel(props: InputLabelProps) {
  return <MuiInputLabel {...props} />;
}
